module.exports = __webpack_public_path__ + "images/external_images/svg/components/teaching-white-icon.svg";